import React,{useEffect} from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { useEyeconxStore } from '../../../store/eyeconxStore'
import clinicService from '../../../services/clinic.service'
import { useNavigate } from 'react-router-dom'
function EcxOffcanvas({show,handleClose}) {
    const userInfo = useEyeconxStore(state => state.userInfo)
    const logout = useEyeconxStore(state => state.logout)
    const navigate = useNavigate()

    const user = useEyeconxStore(state=>state.user)
    const setUserInfo = useEyeconxStore(state=>state.setUserInfo)
   
    useEffect(()=>{
     
      if(userInfo === null){
        getUserInfo()
      }
    },[])
    const getUserInfo = ()=>{
        clinicService.getUserInfo(user.clinicId,user.ID)
        .then(res=>{
          setUserInfo(res.data)
        //  console.log(res.data)
        })
        .catch(err=>{
          console.log(err)
        })
     }

     const handleLogout = ()=>{
      //navigate to login 

      console.log("logout")

        logout()
        navigate('/login')

     }
  return (
   <>
    <Offcanvas placement='end' show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>User Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            {userInfo &&
            <>
            <div className="d-flex flex-column">
                <span className='fw-bold fs-1 mb-3'>{userInfo.firstName && userInfo.firstName} {userInfo.lastName && userInfo.lastName}</span>
                <span className='fs-6 mb-3 text-gray-500'> <i className="bi bi-person"></i> {userInfo.userName}</span>
                <span className='fs-6 text-gray-500 mb-4'><i className="bi bi-envelope"> </i> {userInfo.email}</span>
                
            </div>
             <button className='btn btn-light-primary' onClick={handleLogout}>Sign out</button>
            
             <div className="separator separator-dashed my-5"></div>

             <div className="d-flex flex-column">
                <div className="alert alert-primary d-flex align-items-center p-5 mb-10">
                   <i className="bi bi-person fs-1 me-4"></i>
                    <div className="d-flex flex-column">
                        <h5 className="mb-1">Password Settings</h5>
                        <span>Reset your password.</span>
                    </div>
                </div>
                <div className="alert alert-info d-flex align-items-center p-5 mb-10">
                   <i className="bi bi-person fs-1 me-4"></i>
                    <div className="d-flex flex-column">
                        <h5 className="mb-1">My Activities</h5>
                        <span>Logs and Notifications</span>
                    </div>
                </div>
            </div>
              
               </>
            }
        </Offcanvas.Body>
    </Offcanvas>
   </>
  )
}

export default EcxOffcanvas